import Team from '@/models/team'
import { drop } from 'lodash'
import { ref } from 'vue'
import { CalendarType } from '../../models/calendar'
import AppState from '../../states/app'

export class GroupList {
  filters = ref({
    searchText: '',
    page: 1,
    type: ''
  })

  limit = 100
  type: string

  constructor(type: 'service' | 'sales' | 'all') {
    this.type = type
  }

  get offet() {
    return (this.filters?.value.page - 1) * this.limit
  }

  get teamsList(): Team[] {
    return drop(this.filterdTeams, this.offet)
      .slice(0, this.limit)
      .map(team => {
        team.nosOfCalendars =
          AppState.globalCalendars?.calendars?.filter(
            calendar => team.id === calendar.providerId
          )?.length || 0

        return team
      })
  }

  get filterdTeams() {
    return this.allTeams.filter(team => {
      return (
        this.filters.value.searchText === '' ||
        team.name
          ?.toLowerCase()
          .includes(this.filters.value.searchText?.toLowerCase())
      )
    })
  }

  get teamsFromLocalStorage(): string[] {
    const userId = AppState.user?.id
    const locationId = AppState.locationId
    const teams = localStorage.getItem(`teams_${this.type}_${userId}_${locationId}`)
    return teams ? JSON.parse(teams) : []
  }

  setTeamsInLocalStorage(teams: string[]) {
    const userId = AppState.user?.id
    const locationId = AppState.locationId
    localStorage.setItem(`teams_${this.type}_${userId}_${locationId}`, JSON.stringify(teams))
  }

  get allTeams(): Team[] {
    const teams = AppState.globalTeams?.teams || []
    const teamsFromLocalStorage = this.teamsFromLocalStorage
    const priorityTeamsMap = new Map<string, Team>()
    const priorityTeams: Team[] = []
    const otherTeams: Team[] = []
    teams.forEach(team => {
      if (teamsFromLocalStorage.includes(team.id)) {
        priorityTeamsMap.set(team.id, team)
      } else {
        otherTeams.push(team)
      }
    })
    teamsFromLocalStorage.forEach(teamId => {
      const team = priorityTeamsMap.get(teamId)
      if (team) {
        priorityTeams.push(team)
      }
    })

    return [...priorityTeams, ...otherTeams]
  }

  get nosTotalPages() {
    return Math.ceil(this.filterdTeams.length / this.limit)
  }

  get teamsForCalendars() {
    const allCalendars = AppState.globalCalendars?.calendars || []
    const teamsForSalesCalendars: Team[] = []
    const teamsForServiceCalendars: Team[] = []
    const teamsForAllCalendars: Team[] = []
    if (this.type === 'all') {
      this.filterdTeams.forEach(team => {
        let nosOfCalendars = 0
        allCalendars.forEach(calendar => {
          if (calendar.providerId === team?.id) {
            nosOfCalendars++
          }
        })
        teamsForAllCalendars.push({
          ...team,
          nosOfCalendars: nosOfCalendars,
        } as Team)
      })
      return teamsForAllCalendars
    }
    this.filterdTeams.forEach(team => {
      let nosOfServiceCalendars = 0
      let nosOfSalesCalendars = 0
      allCalendars.forEach(calendar => {
        if (calendar.providerId === team?.id) {
          if (calendar.calendarType === CalendarType.SERVICE) {
            nosOfServiceCalendars++
          } else {
            nosOfSalesCalendars++
          }
        }
      })
      if (nosOfServiceCalendars > 0) {
        teamsForServiceCalendars.push({
          ...team,
          nosOfCalendars: nosOfServiceCalendars,
        } as Team)
      }
      if (nosOfSalesCalendars > 0) {
        teamsForSalesCalendars.push({
          ...team,
          nosOfCalendars: nosOfSalesCalendars,
        } as Team)
      }
      if (nosOfServiceCalendars === 0 && nosOfSalesCalendars === 0) {
        teamsForSalesCalendars.push({
          ...team,
          nosOfCalendars: 0,
        } as Team)
        teamsForServiceCalendars.push({
          ...team,
          nosOfCalendars: 0,
        } as Team)
      }
    })
    if (this.type === 'service') {
      return teamsForServiceCalendars
    } else if (this.type === 'sales') {
      return teamsForSalesCalendars
    } else {
      return [...teamsForServiceCalendars, ...teamsForSalesCalendars]
    }
  }
}
